var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"text-button",attrs:{"type":"button","tabindex":"0"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_c('div',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }